import axios from 'axios';
import { demoBackend } from '../demo/DemoBackend';

const client = axios.create({
    baseURL: '/api',
});

// Flag to enable demo mode
export const setDemoMode = (enabled) => {
    if (enabled) {
        localStorage.setItem('isDemoMode', 'true');
    } else {
        localStorage.removeItem('isDemoMode');
    }
};

client.interceptors.request.use(async (config) => {
    // CHECK FOR DEMO MODE
    if (localStorage.getItem('isDemoMode') === 'true') {
        const adapter = async (config) => {
            return await demoBackend.handleRequest(config);
        };
        config.adapter = adapter;
        return config;
    }

    const token = localStorage.getItem('token');
    if (token) {
        config.headers.Authorization = `Bearer ${token}`;
    }

    // Clean up empty params to avoid 422 errors on backend
    if (config.params) {
        const cleanParams = {};
        Object.keys(config.params).forEach(key => {
            const val = config.params[key];
            if (val !== '' && val !== null && val !== undefined) {
                cleanParams[key] = val;
            }
        });
        config.params = cleanParams;
    }

    return config;
});

client.interceptors.response.use(
    (response) => response,
    (error) => {
        if (error.response && error.response.status === 401) {
            localStorage.removeItem('token');
            if (window.location.pathname !== '/login') {
                window.location.href = '/login';
            }
        }
        return Promise.reject(error);
    }
);

export default client;
